/**
 * Мост «uuid ↔ синтетический номер».
 *
 * Вьюшки страницы задачи писались под legacy, где id сообщений, пунктов
 * чек-листа и пользователей были целыми числами. В v2 везде UUID. Переписывать
 * согласованную вёрстку под строковые id нельзя — это была бы правка дизайна,
 * а не источника данных, — поэтому наружу отдаём порядковые номера, а перед
 * вызовом API переводим их обратно в uuid.
 *
 * Номера синтетические: живут в пределах одного показа, никуда не сохраняются
 * и между перезагрузками не совпадают. Мост поэтому держат в `useRef`, иначе
 * после каждой перерисовки нумерация начиналась бы заново и вьюшка теряла бы
 * своё состояние (раскрытый пункт, выделенное сообщение).
 */
export class IdBridge {
  private toUuid = new Map<number, string>();
  private toNum = new Map<string, number>();
  private next = 1;

  /** Номер этого uuid; на первый вызов заводит новый. */
  num(uuid: string): number {
    const known = this.toNum.get(uuid);
    if (known !== undefined) {
      return known;
    }
    const n = this.next++;
    this.toNum.set(uuid, n);
    this.toUuid.set(n, uuid);

    return n;
  }

  /** Обратный перевод. `undefined` — номер этому мосту не выдавался. */
  uuid(n: number): string | undefined {
    return this.toUuid.get(n);
  }
}
